import { render, staticRenderFns } from "./prePayFeeOrder.vue?vue&type=template&id=5ffa078e&scoped=true"
import script from "./prePayFeeOrder.vue?vue&type=script&lang=js"
export * from "./prePayFeeOrder.vue?vue&type=script&lang=js"
import style0 from "./prePayFeeOrder.vue?vue&type=style&index=0&id=5ffa078e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ffa078e",
  null
  
)

export default component.exports